import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { logEvent } from 'firebase/analytics';

import { episodeList, vodList } from '@/network/apis/apiUri';
import useAxios from '@/network/useAxios';
import useContent from '@/localization/data_export';
import analytics from '../../firebase';
import CommonProgramSearch from './common_program_search';
import './css/common_program_vod.scss';

function CommonProgramVod(props) {
  const { mode, setSubLocation, title } = props;

  const location = useLocation();
  const anchorTitle = useContent(['global', 'anchor', 'title']);

  const boardId = location.pathname.split('/')[4];
  const sliceLocation = location.pathname.split('/').splice(0, 4);

  const [type, settype] = useState();
  const [listEpisode, setListEpisode] = useState({
    board_id: boardId,
    lan_code: mode,
    page_info: {
      row_count: 8,
      number: 0,
    },
  });
  const [listVod, setListVod] = useState({
    board_id: boardId,
    type: null,
    lan_code: mode,
    page_info: {
      row_count: 8,
      number: 0,
    },
  });
  const [listData, setListData] = useState([]);

  const [archiveItem, archiveRefetch] = useAxios(episodeList, [], {}, false);
  const [vodItem, vodRefetch] = useAxios(vodList, [], {}, false);
  const { data: archiveData, loading: epiLoading } = archiveItem;
  const { data: vodListData, loading: vodLoading } = vodItem;

  const dateUpLoad = () => {
    let typeData;
    if (title.data.item) {
      title.data.item.forEach((v) => {
        if (v.board_id === parseInt(location.pathname.split('/')[4])) {
          typeData = v.type;
        }
      });
      if (typeData === 'episode') {
        setListEpisode({
          ...listEpisode,
          page_info: {
            row_count: 8,
            number: listEpisode.page_info.number + 1,
          },
        });
        let copyData = { ...listEpisode };
        copyData.page_info.number = copyData.page_info.number + 1;
        copyData.type = 'episode';
        archiveRefetch(copyData);
      } else if (typeData === 'vod') {
        setListVod({
          ...listVod,
          page_info: {
            row_count: 8,
            number: listVod.page_info.number + 1,
          },
        });
        let copyData = { ...listVod };
        copyData.page_info.number = copyData.page_info.number + 1;
        copyData.type = 'vod';
        vodRefetch(copyData);
      }
    }
  };

  useEffect(() => {
    if (boardId && title.data) {
      let typeData;
      if (title.data.item) {
        title.data.item.forEach((v, i) => {
          if (v.board_id === parseInt(location.pathname.split('/')[4])) {
            typeData = v.type;
          }
        });
      }
      settype(typeData);
      if (typeData === 'episode') {
        setListData([]);
        let copyData = { ...listEpisode };
        copyData.board_id = parseInt(boardId);
        copyData.type = 'episode';
        archiveRefetch(copyData);
      } else if (typeData === 'vod') {
        setListData([]);
        let copyData = { ...listVod };
        copyData.board_id = parseInt(boardId);
        copyData.type = 'vod';
        vodRefetch(copyData);
      }
    }
  }, [boardId, title.data]);

  useEffect(() => {
    if (archiveData) {
      archiveData?.item?.forEach((el) => {
        const obj = {
          board_id: el.board_id,
          board_item_id: el.board_item_id,
          episode_id: el.episode_id,
          title: el.title,
          thumbnail_url: el.image_url,
          is_open_allow: el.is_open_allow,
          reg_date: el.broadcast_date && el.broadcast_date.substring(0, 10),
          tag: el.tags,
        };
        listData.push(obj);
      });
      setListData((prev) => [...prev]);
    }
  }, [archiveData]);

  useEffect(() => {
    if (vodListData) {
      vodListData?.item?.forEach((el) => {
        const obj = {
          board_id: el.board_id,
          board_item_id: el.board_item_id,
          vod_id: el.vod_id,
          title: el.title,
          thumbnail_url: el.image_url,
          is_open_allow: el.is_open_allow,
          reg_date: el.broadcast_date ? el.broadcast_date.substring(0, 10) : '',
        };
        listData.push(obj);
      });
      setListData((prev) => [...prev]);
    }
  }, [vodListData]);

  useEffect(() => {
    setSubLocation(location.pathname);
  }, []);

  return (
    <div id="CommonProgramVod" className="commonProgramVod">
      <section className="commonProgramVod_section">
        <div className="commonProgramVod_section_title-wrap">
          {title &&
            title?.data?.item?.map((v, i) => {
              return (
                <>
                  {v.board_id === parseInt(boardId) ? (
                    <h2 className="title" key={i}>
                      {v.title}
                    </h2>
                  ) : (
                    ''
                  )}
                </>
              );
            })}
          <CommonProgramSearch
            mode={props.mode}
            boardRefetch={(type === 'vod' && vodRefetch) || (type === 'episode' && archiveRefetch)}
            boardData={(type === 'vod' && listVod) || (type === 'episode' && listEpisode)}
            setListData={setListData}
            type={type}
          />
        </div>
        <div className="commonProgramVod_section_content">
          <ul className="list-wrap">
            {listData.length !== 0
              ? listData.map((data) => {
                  return (
                    <li className="list" key={data.board_item_id}>
                      <Link
                        to={
                          data.episode_id
                            ? `${sliceLocation.join('/')}?board=${boardId}&id=${data.episode_id}&sort=episode`
                            : `${sliceLocation.join('/')}?id=${data.vod_id}&board=${boardId}&sort=vod`
                        }
                        className="list_link"
                        onClick={() =>
                          data.episode_id
                            ? logEvent(analytics, 'select_item', {
                                item_list_name: `${data.title}`,
                                item_list_id: `episode_${data.episode_id}`,
                                items: [
                                  {
                                    item_id: `${data.episode_id}`,
                                    item_name: `${data.title}`,
                                    item_brand: 'episode',
                                  },
                                ],
                              })
                            : logEvent(analytics, 'select_item', {
                                item_list_name: `${data.title}`,
                                item_list_id: `vod_${data.vod_id}`,
                                items: [
                                  {
                                    item_id: `${data.vod_id}`,
                                    item_name: `${data.title}`,
                                    item_brand: 'vod',
                                  },
                                ],
                              })
                        }
                        title={anchorTitle}
                      >
                        <div className="list_img">
                          <img
                            className="img"
                            src={`${data.thumbnail_url}`}
                            alt=""
                            onError={(e) => (e.target.src = require('@/assets/images/common/672_379_A.png').default)}
                          />
                        </div>
                        {(location.pathname.split('/')[1] === 'tv' && location.pathname.split('/')[3] === 'archive') ||
                        (location.pathname.split('/')[1] === 'tv' && location.pathname.split('/')[3] === 'vod') ? (
                          <>
                            <div className="list_title-wrap style_0">
                              <h3 className="list_title">{data.title}</h3>
                              <span className="list_date time-fs-fixed">{data.reg_date}</span>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                        {location.pathname.split('/')[1] === 'radio' && location.pathname.split('/')[3] === 'vod' ? (
                          <>
                            <div className="list_title-wrap style_0">
                              <h3 className="list_title">{data.title}</h3>
                              <span className="list_date">{data.reg_date}</span>
                            </div>
                            <p className="list_sub">{data.sub}</p>
                          </>
                        ) : (
                          <></>
                        )}
                      </Link>
                    </li>
                  );
                })
              : null}
          </ul>
          {type === 'vod'
            ? vodListData?.paging_info.total_item_count > listData?.length && (
                <div className="btnMore-wrap">
                  <button type="button" className="btnMore" onClick={() => dateUpLoad()}>
                    More
                  </button>
                </div>
              )
            : archiveData?.paging_info.total_item_count > listData?.length && (
                <div className="btnMore-wrap">
                  <button type="button" className="btnMore" onClick={() => dateUpLoad()}>
                    More
                  </button>
                </div>
              )}
          {vodLoading || epiLoading ? (
            <div className="loading-wrap">
              <img className="loading" src={require('@/assets/images/common/loading.png').default} alt="loading" />
              <p>Now Loading...</p>
            </div>
          ) : (
            listData.length === 0 && (
              <div className="alert" style={{ 'text-align': 'center' }}>
                <img
                  className="alert_img"
                  src={require('@/assets/images/icon/ico_alert.png').default}
                  alt="There is no Podcast yet"
                />
                <p className="alert_text">
                  {'There is no'}
                  {title &&
                    title?.data?.item?.map((v, i) => {
                      return v.board_id === parseInt(boardId) && v.title;
                    })}
                  {` yet`}
                </p>
              </div>
            )
          )}
        </div>
      </section>
    </div>
  );
}

export default CommonProgramVod;
